import { useCallback, useEffect, useState } from "react";

import { useRouter } from "next/router";

import { shouldShowAppBanner } from "@/components/app-banner/should-show-app-banner";

export const useShowAppBanner = () => {
  const router = useRouter();
  const [showBanner, setShowBanner] = useState(false);

  const checkBanner = useCallback(async () => {
    const show = await shouldShowAppBanner(true);
    setShowBanner(show);
  }, []);

  /** Check on mount. */
  useEffect(() => {
    checkBanner();
  }, [checkBanner]);

  useEffect(() => {
    const onRouteChangeComplete = async () => {
      await checkBanner();
    };

    router.events.on("routeChangeComplete", onRouteChangeComplete);

    /** Unmounted - cleanup. */
    return () => {
      router.events.off("routeChangeComplete", onRouteChangeComplete);
    };
  }, [checkBanner, router.events]);

  return showBanner;
};
